<template>
    <div class="data-source-selector">
        <div class="selector-title">Как будут поступать данные для этого проекта?</div>

        <div class="selector-cards">
            <div class="source-card" @click="selectSource('api')">
                <div class="card-icon">
                    <i class="pi pi-link"></i>
                </div>
                <div class="card-title">Из TestDepo</div>
                <div class="card-description">
                    Данные поступают автоматически при прохождении теста.
                    Структура полей загружается из TestDepo.
                </div>
                <PrimeButton label="Выбрать" class="p-button-outlined" />
            </div>

            <div class="source-card" @click="selectSource('manual')">
                <div class="card-icon">
                    <i class="pi pi-table"></i>
                </div>
                <div class="card-title">Вручную</div>
                <div class="card-description">
                    Вы сами зададите поля и внесёте данные из файла
                    или в таблице.
                </div>
                <PrimeButton label="Выбрать" class="p-button-outlined" />
            </div>
        </div>
    </div>
</template>

<script>
import api from "@/libs/api";

export default {
    name: "DataSourceSelector",
    props: {
        project: {
            type: Object,
            required: true
        }
    },
    emits: ['source-selected'],
    methods: {
        async selectSource(source) {
            try {
                await api.setDataSource(this.project.id, source);
                this.$emit('source-selected', source);
            } catch (err) {
                if (err.response && err.response.data.error === 'data_replacement_requires_confirmation') {
                    // Handle in parent - needs confirmation dialog
                    this.$emit('source-selected', source, err.response.data);
                } else {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Ошибка',
                        detail: 'Не удалось сохранить выбор режима',
                        life: 5000
                    });
                }
            }
        }
    }
}
</script>

<style scoped>
.data-source-selector {
    padding: 20px;
}

.selector-title {
    font-size: 1.25rem;
    font-weight: 600;
    margin-bottom: 24px;
    text-align: center;
}

.selector-cards {
    display: flex;
    gap: 24px;
    justify-content: center;
}

.source-card {
    border: 1px solid #dee2e6;
    border-radius: 8px;
    padding: 24px;
    width: 320px;
    cursor: pointer;
    transition: all 0.2s;
    background: #fff;
}

.source-card:hover {
    border-color: #3b82f6;
    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15);
}

.card-icon {
    font-size: 2.5rem;
    color: #3b82f6;
    margin-bottom: 16px;
}

.card-title {
    font-size: 1.25rem;
    font-weight: 600;
    margin-bottom: 12px;
}

.card-description {
    color: #6c757d;
    margin-bottom: 20px;
    line-height: 1.5;
    min-height: 60px;
}
</style>
